export default "__VITE_PUBLIC_ASSET__1e92da9f__"